import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "Store/configureStore";

export const setupOptionsSelector = (state: RootState) => state.setupOptions;

export const setupOptionsConfigSelector = createSelector(
  setupOptionsSelector,
  setupOptions => setupOptions.config
);

export const setupOptionsPlanTitlesSelector = createSelector(
  setupOptionsSelector,
  setupOptions => setupOptions.data?.plan_titles || {}
);

export const setupOptionsRegionsSelector = createSelector(
  setupOptionsSelector,
  setupOptions => setupOptions.data?.regions || []
);
export const setupOptionsIsLoadingRegionsSelector = createSelector(
  setupOptionsSelector,
  setupOptions => setupOptions.loading
);
